var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-row align-items-center justify-content-between"
    },
    [
      _c("div", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("survey.group.resultsModal.footer.passedCount")) +
            "\n    "
        ),
        _c("span", { staticClass: "badge badge-secondary" }, [
          _vm._v(_vm._s(_vm.passedCount))
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("survey.group.resultsModal.footer.totalCount")) +
            "\n    "
        ),
        _c("span", { staticClass: "badge badge-secondary" }, [
          _vm._v(_vm._s(_vm.totalCount))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-center w-25" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("survey.group.resultsModal.footer.progress")) +
            " \n    "
        ),
        _c(
          "div",
          {
            staticClass: "progress flex-grow-1",
            staticStyle: { "margin-top": "0.125em" }
          },
          [
            _c(
              "div",
              {
                staticClass: "progress-bar",
                style: {
                  width: _vm.passedPercent + "%",
                  backgroundColor: _vm.passedPercentColor
                },
                attrs: {
                  role: "progressbar",
                  "aria-valuenow": _vm.passedPercent,
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.passedPercent + "%") + "\n      "
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n    " +
            _vm._s(_vm.$t("survey.group.resultsModal.footer.validCount")) +
            "\n    "
        ),
        _c("span", { staticClass: "badge badge-secondary" }, [
          _vm._v(_vm._s(_vm.validCount))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }